import ConservationChicagoStyle from "../assets/files/history/conservation_chicago_style.pdf";
import DawningOfABotanist from "../assets/files/history/dawning_of_a_botanist.pdf";
import FloraChicago from "../assets/files/history/flora_chicago_endnote.pdf";
import Otankik from "../assets/files/history/otankik.pdf";
import PlantOfChicago from "../assets/files/history/plants_of_the_chicago_region.pdf";
import SynopsisOfEcohistory from "../assets/files/history/synopsis_of_ecohistory.pdf";

interface EssayType {
  name: string;
  file: string;
}

export const HistoryEssays: EssayType[] = [
  {
    name: "Conservation Chicago Style",
    file: ConservationChicagoStyle,
  },
  {
    name: "Dawning of a Botanist",
    file: DawningOfABotanist,
  },
  {
    name: "Flora of the Chicago Region",
    file: FloraChicago,
  },
  {
    name: "Otankik",
    file: Otankik,
  },
  {
    name: "Plants of the Chicago Region",
    file: PlantOfChicago,
  },
  {
    name: "Synopsis of Ecohistory",
    file: SynopsisOfEcohistory,
  },
];

export default HistoryEssays;
export type { EssayType };
